import React, { Component } from "react";

export default class Resume extends Component {
  render() {
    return (
      <section id="resume">
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>University of Cádiz</h3>
                <p className="info">
                  Science degree in computer engineering <span>•</span>{" "}
                  <em className="date">2018 - 2017</em>
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>University of Cádiz</h3>
                <p className="info">
                  Bachelor degree in computer engineering <span>•</span>{" "}
                  <em className="date">2004 - 2008</em>
                </p>
              </div>
            </div>{" "}
            {/* item end */}
          </div>{" "}
          {/* main-col end */}
        </div>{" "}
        {/* End Education */}
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Certifications</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>EuropeanScrum.org</h3>
                <p className="info">
                  Oficial Certification Expert Scrum Foundations (ESCF){" "}
                  <span>•</span> <em className="date">June 2016</em>
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>EuropeanScrum.org</h3>
                <p className="info">
                  Oficial Certification Expert Scrum Master (SCM) <span>•</span>{" "}
                  <em className="date">June 2016</em>
                </p>
              </div>
            </div>{" "}
            {/* item end */}
          </div>{" "}
          {/* main-col end */}
        </div>{" "}
        {/* End Education */}
        {/* Work
    ----------------------------------------------- */}
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Work</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>Plexus Tech - Meliá Hotels</h3>
                <p className="info">
                  Software Architect - Technical Leader <span>•</span>{" "}
                  <em className="date">April 2017 - Present</em>
                </p>
                <p>
                  Team leader and development technician, covering architecture,
                  analysis, design and software development tasks using JAVA in
                  J2EE environment using Web Services, Spring Boot, Maven, Rest
                  as well as Web application developments with Javascript, using
                  JSON, HTML, CSS, XML, AngularJS, Angular 4. Use of management
                  tools and version control such as GIT, Subversion, Sonar,
                  Jenkins, JIRA. Design and architecture solution for
                  applications. Responsible for ensuring the technical quality
                  as well as the performance of the applications implemented by
                  the team. Supervise the technical execution of tasks and
                  provide technical support to the team. Periodically review
                  technical procedures, improving them when possible. Provide
                  technical and functional assistance to work teams located
                  remotely.
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>FrontJS</h3>
                <p className="info">
                  Co-Founder - Technical manager and trainer <span>•</span>{" "}
                  <em className="date">September 2016 - Present</em>
                </p>
                <p>
                  Consulting and specialized training in the Angular framework
                  and VueJS library. After several years focused on the
                  development accumulating experiences and helping in the
                  projects, we decided to take the step and form Front JS to
                  help our clients to give solutions. We are highly specialized
                  in the Angular framework in its different versions, which
                  helps us that our training and courses are highly usable by
                  the attendees. In addition to Angular we offer solutions for
                  different technologies for both Frontend and Backend
                  environments, we offer VueJS in its different versions, we
                  have solid knowledge in GIT, TDD, design and implementation of
                  API's Rest, JEE architecture and development, web
                  applications, continuous integration, agile methodologies ,
                  management, analysis and design. We are able to find fast,
                  practical and efficient solutions to achieve the best result.
                  We are professionals and we evolve every day always looking
                  for new trends and resources.
                  <br />
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.frontjs.es"
                  >
                    www.frontjs.es
                  </a>
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>Hiberus Travel</h3>
                <p className="info">
                  Software Architect - Team and Technical Leader <span>•</span>{" "}
                  <em className="date">July 2016 - April 2017</em>
                </p>
                <p>
                  Team and technical leader, development technician, covering
                  architecture, analysis, design and software development tasks
                  using JAVA in J2EE environment using Web Services, Maven,
                  Rest, Ajax, JavasCript, JSON, HTML, CSS, XML, AngularJS, GIT,
                  Subversion, Sonar, Jenkins, JIRA, NodeJS. Design and
                  architecture solution for applications. Responsible for
                  ensuring the technical quality as well as the performance of
                  the applications implemented by the team. Supervise the
                  technical execution of tasks and provide technical support to
                  the team. Periodically review technical procedures, improving
                  them when possible. Provide technical and functional
                  assistance to work teams located remotely.
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>Hotelbeds Group</h3>
                <p className="info">
                  Fullstack Developer - Technical Designer <span>•</span>{" "}
                  <em className="date">June 2014 - July 2016</em>
                </p>
                <p>
                  Architecture, analysis, design and development of Software
                  using JAVA in J2EE environment using Mybatis, Spring,
                  SpringMVC, Web Services, Maven, Rest, Ajax, JavasCript, JSON,
                  HTML, CSS, XML, AngularJS, GIT, Subversion, Sonar, Jenkins,
                  Bamboo, JIRA, NodeJS. Design and architecture solution for
                  applications. Responsible for ensuring the technical quality
                  as well as the performance of the applications implemented by
                  the team. Supervise the technical execution of tasks and
                  provide technical support to the team. Periodically review
                  technical procedures, improving them when possible. Provide
                  technical and functional assistance to work teams located
                  remotely.
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>Barceló Viajes</h3>
                <p className="info">
                  Fullstack Developer - Analyst Developer <span>•</span>{" "}
                  <em className="date">May 2014 - June 2014</em>
                </p>
                <p>
                  Architecture, analysis, design and development of Software
                  using JAVA in J2EE environment using Hibernate, Struts, Maven,
                  Ajax, JSF, Web Services, JavasCript, JSON, HTML, XML, ORACLE,
                  JSP, Subversion. Responsible for ensuring the technical
                  quality as well as the performance of the applications
                  implemented by the team. Supervise the technical execution of
                  tasks and provide technical support to the team. Management of
                  development team.
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>AtSistemas</h3>
                <p className="info">
                  Fullstack Developer - Analyst Developer <span>•</span>{" "}
                  <em className="date">April 2010 - April 2014</em>
                </p>
                <p>
                  Architecture, analysis, design and development of Software
                  using JAVA in J2EE environment using Hibernate, Ibatis,
                  MyBatis, Struts, Struts2, Spring, SpringMVC, Web Services,
                  Alfresco, Maven, xQuid, Rest, Ajax, JavasCript, JSON, HTML,
                  XML, MySQL, JSP, JIRA, Sonar, GIT, Subversion. Management of
                  development team.
                </p>
              </div>
            </div>{" "}
            {/* item end */}
            <div className="row item">
              <div className="twelve columns">
                <h3>AYESA</h3>
                <p className="info">
                  Fullstack Developer <span>•</span>{" "}
                  <em className="date">March 2009 - April 2010</em>
                </p>
                <p>
                  Analysis and development of Software using JAVA in J2EE
                  environment, ORACLE (Forms, Reports, PL / SQL), SAP, Struts,
                  Struts2, AJAX, JSF, JSP, Spring, Web Services, JavasCript,
                  HTML, XML. Realizing the creation, study of data model and
                  development of Databases in different Database Management
                  Systems.
                </p>
              </div>
            </div>{" "}
            {/* item end */}
          </div>{" "}
          {/* main-col end */}
        </div>{" "}
        {/* End Work */}
        {/* Skills
    ----------------------------------------------- */}
        <div className="row skill">
          <div className="three columns header-col">
            <h1>
              <span>Skills</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            <div className="bars">
              <ul className="skills">
                <ul>
                  <li>JavaScript</li>
                  <li>Java</li>
                  <li>Go</li>
                  <li>NodeJS</li>
                  <li>Angular</li>
                  <li>React</li>
                  <li>Vue</li>
                  <li>C</li>
                  <li>C++</li>
                  <li>TDD</li>
                  <li>Spring Framework</li>
                  <li>Maven</li>
                  <li>Docker</li>
                  <li>HTML</li>
                  <li>CSS</li>
                  <li>Sass</li>
                  <li>Redux</li>
                  <li>UI/UX</li>
                  <li>Express</li>
                  <li>Mongo</li>
                  <li>AWS</li>
                  <li>Oracle</li>
                  <li>MySQL</li>
                  <li>Redis</li>
                  <li>GIT</li>
                  <li>JIRA</li>
                  <li>Scrum</li>
                  <li>Kotlin</li>
                  <li>TypeScript</li>
                  <li>GraphQL</li>
                  <li>Jenkins</li>
                  <li>CircleCI</li>
                  <li>GitLab</li>
                  <li>Responsive</li>
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
